/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }

function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));) { ; } return t; }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var c = require("@lexical/clipboard"),
    g = require("@lexical/selection"),
    h = require("@lexical/utils"),
    k = require("lexical");

function l(b, a) {
  return "undefined" !== typeof document.caretRangeFromPoint ? (b = document.caretRangeFromPoint(b, a), null === b ? null : {
    node: b.startContainer,
    offset: b.startOffset
  }) : "undefined" !== document.caretPositionFromPoint ? (b = document.caretPositionFromPoint(b, a), null === b ? null : {
    node: b.offsetNode,
    offset: b.offset
  }) : null;
}

var n = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement,
    p = n && "documentMode" in document ? document.documentMode : null;
n && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
n && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
var q = n && "InputEvent" in window && !p ? "getTargetRanges" in new window.InputEvent("input") : !1,
    r = n && /Version\/[\d.]+.*Safari/.test(navigator.userAgent),
    t = n && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    u = n && /^(?=.*Chrome).*/i.test(navigator.userAgent),
    v = n && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !u,
    w = k.createCommand("DRAG_DROP_PASTE_FILE");

var x = /*#__PURE__*/function (_k$ElementNode) {
  _inherits(x, _k$ElementNode);

  var _super = _createSuper(x);

  function x(b) {
    _classCallCheck(this, x);

    return _super.call(this, b);
  }

  _createClass(x, [{
    key: "createDOM",
    value: function createDOM(b) {
      var a = document.createElement("blockquote");
      h.addClassNamesToElement(a, b.theme.quote);
      return a;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return !1;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(b) {
      var _get$call = _get(_getPrototypeOf(x.prototype), "exportDOM", this).call(this, b);

      b = _get$call.element;

      if (b && h.isHTMLElement(b)) {
        this.isEmpty() && b.append(document.createElement("br"));
        var a = this.getFormatType();
        b.style.textAlign = a;
        if (a = this.getDirection()) b.dir = a;
      }

      return {
        element: b
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(x.prototype), "exportJSON", this).call(this)), {}, {
        type: "quote"
      });
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(b, a) {
      b = k.$createParagraphNode();
      var d = this.getDirection();
      b.setDirection(d);
      this.insertAfter(b, a);
      return b;
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart() {
      var b = k.$createParagraphNode();
      this.getChildren().forEach(function (a) {
        return b.append(a);
      });
      this.replace(b);
      return !0;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "quote";
    }
  }, {
    key: "clone",
    value: function clone(b) {
      return new x(b.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        blockquote: function blockquote() {
          return {
            conversion: y,
            priority: 0
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(b) {
      var a = z();
      a.setFormat(b.format);
      a.setIndent(b.indent);
      a.setDirection(b.direction);
      return a;
    }
  }]);

  return x;
}(k.ElementNode);

function z() {
  return k.$applyNodeReplacement(new x());
}

var B = /*#__PURE__*/function (_k$ElementNode2) {
  _inherits(B, _k$ElementNode2);

  var _super2 = _createSuper(B);

  function B(b, a) {
    var _this;

    _classCallCheck(this, B);

    _this = _super2.call(this, a);
    _this.__tag = b;
    return _this;
  }

  _createClass(B, [{
    key: "getTag",
    value: function getTag() {
      return this.__tag;
    }
  }, {
    key: "createDOM",
    value: function createDOM(b) {
      var a = this.__tag,
          d = document.createElement(a);
      b = b.theme.heading;
      void 0 !== b && h.addClassNamesToElement(d, b[a]);
      return d;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return !1;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(b) {
      var _get$call2 = _get(_getPrototypeOf(B.prototype), "exportDOM", this).call(this, b);

      b = _get$call2.element;

      if (b && h.isHTMLElement(b)) {
        this.isEmpty() && b.append(document.createElement("br"));
        var a = this.getFormatType();
        b.style.textAlign = a;
        if (a = this.getDirection()) b.dir = a;
      }

      return {
        element: b
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(B.prototype), "exportJSON", this).call(this)), {}, {
        tag: this.getTag(),
        type: "heading",
        version: 1
      });
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(b) {
      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      b = b ? b.anchor.offset : 0;
      b = 0 < b && b < this.getTextContentSize() ? E(this.getTag()) : k.$createParagraphNode();
      var d = this.getDirection();
      b.setDirection(d);
      this.insertAfter(b, a);
      return b;
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart() {
      var b = this.isEmpty() ? k.$createParagraphNode() : E(this.getTag());
      this.getChildren().forEach(function (a) {
        return b.append(a);
      });
      this.replace(b);
      return !0;
    }
  }, {
    key: "extractWithChild",
    value: function extractWithChild() {
      return !0;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "heading";
    }
  }, {
    key: "clone",
    value: function clone(b) {
      return new B(b.__tag, b.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        h1: function h1() {
          return {
            conversion: C,
            priority: 0
          };
        },
        h2: function h2() {
          return {
            conversion: C,
            priority: 0
          };
        },
        h3: function h3() {
          return {
            conversion: C,
            priority: 0
          };
        },
        h4: function h4() {
          return {
            conversion: C,
            priority: 0
          };
        },
        h5: function h5() {
          return {
            conversion: C,
            priority: 0
          };
        },
        h6: function h6() {
          return {
            conversion: C,
            priority: 0
          };
        },
        p: function p(b) {
          b = b.firstChild;
          return null !== b && D(b) ? {
            conversion: function conversion() {
              return {
                node: null
              };
            },
            priority: 3
          } : null;
        },
        span: function span(b) {
          return D(b) ? {
            conversion: function conversion() {
              return {
                node: E("h1")
              };
            },
            priority: 3
          } : null;
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(b) {
      var a = E(b.tag);
      a.setFormat(b.format);
      a.setIndent(b.indent);
      a.setDirection(b.direction);
      return a;
    }
  }]);

  return B;
}(k.ElementNode);

function D(b) {
  return "span" === b.nodeName.toLowerCase() ? "26pt" === b.style.fontSize : !1;
}

function C(b) {
  var a = b.nodeName.toLowerCase(),
      d = null;
  if ("h1" === a || "h2" === a || "h3" === a || "h4" === a || "h5" === a || "h6" === a) d = E(a), null !== b.style && d.setFormat(b.style.textAlign);
  return {
    node: d
  };
}

function y(b) {
  var a = z();
  null !== b.style && a.setFormat(b.style.textAlign);
  return {
    node: a
  };
}

function E(b) {
  return k.$applyNodeReplacement(new B(b));
}

function F(b, a) {
  b.preventDefault();
  a.update(function () {
    var d = k.$getSelection(),
        e = b instanceof InputEvent || b instanceof KeyboardEvent ? null : b.clipboardData;
    null != e && (k.$isRangeSelection(d) || k.DEPRECATED_$isGridSelection(d)) && c.$insertDataTransferForRichText(e, d, a);
  }, {
    tag: "paste"
  });
}

function G(_x, _x2) {
  return _G.apply(this, arguments);
}

function _G() {
  _G = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(b, a) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return c.copyToClipboard(a, h.objectKlassEquals(b, ClipboardEvent) ? b : null);

          case 2:
            a.update(function () {
              var d = k.$getSelection();
              k.$isRangeSelection(d) ? d.removeText() : k.$isNodeSelection(d) && d.getNodes().forEach(function (e) {
                return e.remove();
              });
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _G.apply(this, arguments);
}

function H(b) {
  var a = null;
  b instanceof DragEvent ? a = b.dataTransfer : b instanceof ClipboardEvent && (a = b.clipboardData);
  if (null === a) return [!1, [], !1];
  var d = a.types;
  b = d.includes("Files");
  d = d.includes("text/html") || d.includes("text/plain");
  return [b, Array.from(a.files), d];
}

function I(b) {
  var a = k.$getSelection();
  if (!k.$isRangeSelection(a)) return !1;
  var d = new Set();
  a = a.getNodes();

  for (var m = 0; m < a.length; m++) {
    var e = a[m],
        f = e.getKey();
    d.has(f) || (e = h.$getNearestBlockElementAncestorOrThrow(e), f = e.getKey(), e.canIndent() && !d.has(f) && (d.add(f), b(e)));
  }

  return 0 < d.size;
}

function J(b) {
  b = k.$getNearestNodeFromDOMNode(b);
  return k.$isDecoratorNode(b);
}

exports.$createHeadingNode = E;
exports.$createQuoteNode = z;

exports.$isHeadingNode = function (b) {
  return b instanceof B;
};

exports.$isQuoteNode = function (b) {
  return b instanceof x;
};

exports.DRAG_DROP_PASTE = w;
exports.HeadingNode = B;
exports.QuoteNode = x;
exports.eventFiles = H;

exports.registerRichText = function (b) {
  return h.mergeRegister(b.registerCommand(k.CLICK_COMMAND, function () {
    var a = k.$getSelection();
    return k.$isNodeSelection(a) ? (a.clear(), !0) : !1;
  }, 0), b.registerCommand(k.DELETE_CHARACTER_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    d.deleteCharacter(a);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DELETE_WORD_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    d.deleteWord(a);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DELETE_LINE_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    d.deleteLine(a);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.CONTROLLED_TEXT_INSERTION_COMMAND, function (a) {
    var d = k.$getSelection();
    if ("string" === typeof a) k.$isRangeSelection(d) ? d.insertText(a) : k.DEPRECATED_$isGridSelection(d);else {
      if (!k.$isRangeSelection(d) && !k.DEPRECATED_$isGridSelection(d)) return !1;
      var e = a.dataTransfer;
      null != e ? c.$insertDataTransferForRichText(e, d, b) : k.$isRangeSelection(d) && (a = a.data) && d.insertText(a);
    }
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.REMOVE_TEXT_COMMAND, function () {
    var a = k.$getSelection();
    if (!k.$isRangeSelection(a)) return !1;
    a.removeText();
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.FORMAT_TEXT_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    d.formatText(a);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.FORMAT_ELEMENT_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d) && !k.$isNodeSelection(d)) return !1;
    d = d.getNodes();

    var _iterator = _createForOfIteratorHelper(d),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        d = h.$findMatchingParent(e, function (f) {
          return k.$isElementNode(f) && !f.isInline();
        }), null !== d && d.setFormat(a);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INSERT_LINE_BREAK_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    d.insertLineBreak(a);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INSERT_PARAGRAPH_COMMAND, function () {
    var a = k.$getSelection();
    if (!k.$isRangeSelection(a)) return !1;
    a.insertParagraph();
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INSERT_TAB_COMMAND, function () {
    k.$insertNodes([k.$createTabNode()]);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INDENT_CONTENT_COMMAND, function () {
    return I(function (a) {
      var d = a.getIndent();
      a.setIndent(d + 1);
    });
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.OUTDENT_CONTENT_COMMAND, function () {
    return I(function (a) {
      var d = a.getIndent();
      0 < d && a.setIndent(d - 1);
    });
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_UP_COMMAND, function (a) {
    var d = k.$getSelection();

    if (k.$isNodeSelection(d) && !J(a.target)) {
      if (a = d.getNodes(), 0 < a.length) return a[0].selectPrevious(), !0;
    } else if (k.$isRangeSelection(d) && (d = k.$getAdjacentNode(d.focus, !0), !a.shiftKey && k.$isDecoratorNode(d) && !d.isIsolated() && !d.isInline())) return d.selectPrevious(), a.preventDefault(), !0;

    return !1;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_DOWN_COMMAND, function (a) {
    var d = k.$getSelection();

    if (k.$isNodeSelection(d)) {
      if (a = d.getNodes(), 0 < a.length) return a[0].selectNext(0, 0), !0;
    } else if (k.$isRangeSelection(d)) {
      var e = d.focus;
      if ("root" === e.key && e.offset === k.$getRoot().getChildrenSize()) return a.preventDefault(), !0;
      d = k.$getAdjacentNode(d.focus, !1);
      if (!a.shiftKey && k.$isDecoratorNode(d) && !d.isIsolated() && !d.isInline()) return d.selectNext(), a.preventDefault(), !0;
    }

    return !1;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_LEFT_COMMAND, function (a) {
    var d = k.$getSelection();

    if (k.$isNodeSelection(d)) {
      var e = d.getNodes();
      if (0 < e.length) return a.preventDefault(), e[0].selectPrevious(), !0;
    }

    return k.$isRangeSelection(d) ? g.$shouldOverrideDefaultCharacterSelection(d, !0) ? (e = a.shiftKey, a.preventDefault(), g.$moveCharacter(d, e, !0), !0) : !1 : !1;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_RIGHT_COMMAND, function (a) {
    var d = k.$getSelection();

    if (k.$isNodeSelection(d) && !J(a.target)) {
      var e = d.getNodes();
      if (0 < e.length) return a.preventDefault(), e[0].selectNext(0, 0), !0;
    }

    if (!k.$isRangeSelection(d)) return !1;
    e = a.shiftKey;
    return g.$shouldOverrideDefaultCharacterSelection(d, !1) ? (a.preventDefault(), g.$moveCharacter(d, e, !1), !0) : !1;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_BACKSPACE_COMMAND, function (a) {
    if (J(a.target)) return !1;
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    a.preventDefault();
    a = d.anchor;
    var e = a.getNode();
    return d.isCollapsed() && 0 === a.offset && !k.$isRootNode(e) && 0 < h.$getNearestBlockElementAncestorOrThrow(e).getIndent() ? b.dispatchCommand(k.OUTDENT_CONTENT_COMMAND, void 0) : b.dispatchCommand(k.DELETE_CHARACTER_COMMAND, !0);
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_DELETE_COMMAND, function (a) {
    if (J(a.target)) return !1;
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;
    a.preventDefault();
    return b.dispatchCommand(k.DELETE_CHARACTER_COMMAND, !1);
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ENTER_COMMAND, function (a) {
    var d = k.$getSelection();
    if (!k.$isRangeSelection(d)) return !1;

    if (null !== a) {
      if ((t || r || v) && q) return !1;
      a.preventDefault();
      if (a.shiftKey) return b.dispatchCommand(k.INSERT_LINE_BREAK_COMMAND, !1);
    }

    return b.dispatchCommand(k.INSERT_PARAGRAPH_COMMAND, void 0);
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ESCAPE_COMMAND, function () {
    var a = k.$getSelection();
    if (!k.$isRangeSelection(a)) return !1;
    b.blur();
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DROP_COMMAND, function (a) {
    var _H = H(a),
        _H2 = _slicedToArray(_H, 2),
        d = _H2[1];

    if (0 < d.length) {
      var e = l(a.clientX, a.clientY);

      if (null !== e) {
        var _e = e,
            m = _e.offset,
            K = _e.node;
        var f = k.$getNearestNodeFromDOMNode(K);

        if (null !== f) {
          e = k.$createRangeSelection();
          if (k.$isTextNode(f)) e.anchor.set(f.getKey(), m, "text"), e.focus.set(f.getKey(), m, "text");else {
            var A = f.getParentOrThrow().getKey();
            f = f.getIndexWithinParent() + 1;
            e.anchor.set(A, f, "element");
            e.focus.set(A, f, "element");
          }
          e = k.$normalizeSelection__EXPERIMENTAL(e);
          k.$setSelection(e);
        }

        b.dispatchCommand(w, d);
      }

      a.preventDefault();
      return !0;
    }

    a = k.$getSelection();
    return k.$isRangeSelection(a) ? !0 : !1;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DRAGSTART_COMMAND, function (a) {
    var _H3 = H(a);

    var _H4 = _slicedToArray(_H3, 1);

    a = _H4[0];
    var d = k.$getSelection();
    return a && !k.$isRangeSelection(d) ? !1 : !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DRAGOVER_COMMAND, function (a) {
    var _H5 = H(a),
        _H6 = _slicedToArray(_H5, 1),
        d = _H6[0];

    var e = k.$getSelection();
    if (d && !k.$isRangeSelection(e)) return !1;
    d = l(a.clientX, a.clientY);
    null !== d && (d = k.$getNearestNodeFromDOMNode(d.node), k.$isDecoratorNode(d) && a.preventDefault());
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.SELECT_ALL_COMMAND, function () {
    k.$selectAll();
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.COPY_COMMAND, function (a) {
    c.copyToClipboard(b, h.objectKlassEquals(a, ClipboardEvent) ? a : null);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.CUT_COMMAND, function (a) {
    G(a, b);
    return !0;
  }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.PASTE_COMMAND, function (a) {
    var _H7 = H(a),
        _H8 = _slicedToArray(_H7, 3),
        d = _H8[1],
        e = _H8[2];

    if (0 < d.length && !e) return b.dispatchCommand(w, d), !0;
    if (k.isSelectionCapturedInDecoratorInput(a.target)) return !1;
    var f = k.$getSelection();
    return k.$isRangeSelection(f) || k.DEPRECATED_$isGridSelection(f) ? (F(a, b), !0) : !1;
  }, k.COMMAND_PRIORITY_EDITOR));
};